module.exports = __webpack_public_path__ + "media/bootstrap-icons/plus-e4d7be0f.svg";